import React from 'react';
import { formatFullName, formatSSN, getAttrValue } from 'helpers/Helpers';
import { setSubjectName, setSubjectSSN, setSpouseName, setSpouseSSN, setReportType } from 'store/store';

export default function ApplicantInformation({bors}) {

  var subs0 = null;
  var subs1 = null;
  if (bors.length === undefined) {
    subs0 = bors;
  } else {
    subs0 = bors[0];
    subs1 = bors[1];
  }

  var subjectName = getAttrValue(subs0, "_UnparsedName");
	var subjectSSN = formatSSN(subs0);
  var reportType = '';
  var spouseName = '';
  var spouseSSN = '';

  if (subs1) {
    reportType = 'joint';
    spouseName = getAttrValue(subs1, "_UnparsedName");
    spouseSSN = formatSSN(subs1);
  } else {
    reportType = 'single';
  }

  setReportType(reportType);
  setSubjectName(subjectName);
  setSubjectSSN(subjectSSN);
  setSpouseName(spouseName);
  setSpouseSSN(spouseSSN);

	//console.log("state: ", state);
  //updateReportState(state);


	return (
    <div className="w-full flex flex-col">
      <div className="header-bar">
        <div className="w-6/12 header-text">Applicant</div>
        <div className="header-text">Spouse</div>
      </div>
      <div className="w-full flex flex-col border-2 value">
        <div className="w-full flex flex-row border-b-2">
          <div className="w-full px-2 border-r-2">{subjectName}</div>
          <div className="w-3/12 text-center title border-r-2">Name</div>
          <div className="w-full px-2">{spouseName}</div>
        </div>
        <div className="w-full flex flex-row">
          <div className="w-full px-2 border-r-2">{subjectSSN}</div>
          <div className="w-3/12 text-center title border-r-2">SSN/DOB</div>
          <div className="w-full px-2">{spouseSSN}</div>
        </div>
      </div>
    </div>
  );
}
